(function () {
  'use strict';

  var LEAVE_DELAY = 250;

  var items = document.querySelectorAll('[data-has-mega-menu]');
  if (!items.length) return;

  var leaveTimers = new Map();
  var shopNavItem = document.querySelector('[data-shop-drawer]');
  var shopMega = document.querySelector('[data-mega-trigger="shop"]');
  var shopTrigger = shopNavItem ? getTrigger(shopNavItem) : null;
  var tabLinks = shopMega ? shopMega.querySelectorAll('[data-shop-tab]') : [];
  var promoPanels = shopMega ? shopMega.querySelectorAll('[data-promo-panel]') : [];
  var shopDetail = shopMega ? shopMega.querySelector('[data-shop-detail]') : null;
  var shopCloseButtons = shopMega ? shopMega.querySelectorAll('[data-shop-close]') : [];
  var shopRootButtons = shopMega ? shopMega.querySelectorAll('[data-shop-root]') : [];

  function getTrigger(item) {
    return item.querySelector('.kith-nav__link, .kith-nav__btn');
  }

  function hydrateDeferredImages(root) {
    if (!root) return;

    var images = root.querySelectorAll('.wcwy-deferred-img[data-src], .wcwy-deferred-img[data-srcset]');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      var src = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      var sizes = img.getAttribute('data-sizes');

      if (sizes) {
        img.setAttribute('sizes', sizes);
        img.removeAttribute('data-sizes');
      }

      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }

      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
      }

      img.classList.remove('wcwy-deferred-img');
    }
  }

  function resetShopDrawer() {
    if (!shopMega) return;

    shopMega.classList.remove('is-detail-open');

    if (shopDetail) {
      shopDetail.setAttribute('aria-hidden', 'true');
    }

    promoPanels.forEach(function (panel) {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
    });

    tabLinks.forEach(function (link) {
      link.classList.remove('is-tab-active');
      link.setAttribute('aria-expanded', 'false');
    });
  }

  function openPanel(item) {
    items.forEach(function (other) {
      if (other !== item) closePanel(other);
    });

    item.classList.add('is-mega-open');
    hydrateDeferredImages(item);

    if (item === shopNavItem) {
      document.body.classList.add('no-scroll');
    }

    var trigger = getTrigger(item);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closePanel(item) {
    item.classList.remove('is-mega-open');

    if (item === shopNavItem) {
      resetShopDrawer();
      document.body.classList.remove('no-scroll');
    }

    var trigger = getTrigger(item);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAll() {
    items.forEach(function (item) {
      closePanel(item);
    });
  }

  items.forEach(function (item) {
    var trigger = getTrigger(item);
    var isShop = item.hasAttribute('data-shop-drawer');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-haspopup', 'true');
    }

    if (isShop) {
      if (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();

          var isOpen = item.classList.contains('is-mega-open');
          closeAll();

          if (!isOpen) openPanel(item);
        });
      }

      item.addEventListener('mouseenter', function () {
        clearTimeout(leaveTimers.get(item));
        leaveTimers.delete(item);
        openPanel(item);
      });

      item.addEventListener('mouseleave', function () {
        var timer = setTimeout(function () {
          closePanel(item);
          leaveTimers.delete(item);
        }, LEAVE_DELAY);
        leaveTimers.set(item, timer);
      });
    } else {
      item.addEventListener('mouseenter', function () {
        clearTimeout(leaveTimers.get(item));
        leaveTimers.delete(item);
        openPanel(item);
      });

      item.addEventListener('mouseleave', function () {
        var timer = setTimeout(function () {
          closePanel(item);
          leaveTimers.delete(item);
        }, LEAVE_DELAY);

        leaveTimers.set(item, timer);
      });
    }

    item.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePanel(item);
        if (trigger) trigger.focus();
      }
    });
  });

  document.addEventListener('focusin', function (event) {
    var nav = document.querySelector('.kith-header__left');
    if (nav && !nav.contains(event.target)) closeAll();
  });

  document.addEventListener('click', function (event) {
    var shopItem = document.querySelector('[data-shop-drawer]');
    if (!shopItem || !shopItem.classList.contains('is-mega-open')) return;

    if (!shopItem.contains(event.target)) closePanel(shopItem);
  });

  if (!shopMega) return;

  // Close shop on hover-out: the fixed overlay covers inset:0, so mouseleave on the
  // nav item never fires once the panel is open. Instead listen to the inner container.
  var shopContainer = shopMega.querySelector('.wcwy-mega-menu__container');
  if (shopNavItem && shopContainer) {
    shopContainer.addEventListener('mouseenter', function () {
      clearTimeout(leaveTimers.get(shopNavItem));
      leaveTimers.delete(shopNavItem);
    });

    shopContainer.addEventListener('mouseleave', function () {
      var timer = setTimeout(function () {
        closePanel(shopNavItem);
        leaveTimers.delete(shopNavItem);
      }, LEAVE_DELAY);
      leaveTimers.set(shopNavItem, timer);
    });
  }

  // The fixed SHOP scrim is a child of the nav item, so leaving the panel for
  // the scrim does not count as leaving the nav item itself. Treat entry onto
  // that exposed scrim as hover-out while preserving the small forgiveness
  // delay for users moving back into the panel.
  shopMega.addEventListener('mouseover', function (event) {
    if (event.target !== shopMega || !shopNavItem) return;
    clearTimeout(leaveTimers.get(shopNavItem));
    var timer = setTimeout(function () {
      closePanel(shopNavItem);
      leaveTimers.delete(shopNavItem);
    }, LEAVE_DELAY);
    leaveTimers.set(shopNavItem, timer);
  });

  function activateTab(tabId) {
    var hasActivePanel = false;

    promoPanels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-promo-panel') === tabId;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      if (isActive) hasActivePanel = true;
    });

    tabLinks.forEach(function (link) {
      var isActive = link.getAttribute('data-shop-tab') === tabId;
      link.classList.toggle('is-tab-active', isActive);
      link.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    shopMega.classList.toggle('is-detail-open', hasActivePanel);

    if (shopDetail) {
      shopDetail.setAttribute('aria-hidden', hasActivePanel ? 'false' : 'true');
    }
  }

  if (shopTrigger) {
    shopTrigger.addEventListener('click', function () {
      if (shopNavItem && shopNavItem.classList.contains('is-mega-open')) {
        resetShopDrawer();
      }
    });
  }

  shopMega.addEventListener('click', function (event) {
    if (event.target === shopMega && shopNavItem) {
      closePanel(shopNavItem);
    }
  });

  tabLinks.forEach(function (link) {
    if (link.disabled) return;

    link.addEventListener('click', function (event) {
      event.preventDefault();

      var tabId = link.getAttribute('data-shop-tab');
      var isActive = link.classList.contains('is-tab-active') && shopMega.classList.contains('is-detail-open');

      if (isActive) {
        resetShopDrawer();
        return;
      }

    activateTab(tabId);
    hydrateDeferredImages(shopMega.querySelector('[data-promo-panel="' + tabId + '"]'));
  });
  });

  shopCloseButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (shopNavItem) closePanel(shopNavItem);
      if (shopTrigger) shopTrigger.focus();
    });
  });

  shopRootButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var activeRootLink = shopMega.querySelector('[data-shop-tab].is-tab-active');
      resetShopDrawer();
      if (activeRootLink) activeRootLink.focus();
    });
  });

  resetShopDrawer();
})();
